<script lang="ts">
    import { navstore, sprache } from "../store"
    import LadeAnimation from "./LadeAnimation.svelte"

    import Navigation from "./Navigation.svelte"
    import Suchfeld from "./Suchfeld.svelte"

    let selectopen = false
    let navopen = false
    let searchopen = false
</script>

<header id="header">
    <div class="inner">
        <div id="logo">
            <a href="/{$sprache != 'de' ? $sprache : ''}"
                ><img src="/media/Logo_{$sprache}.svg" alt="" /></a
            >
        </div>
        <div id="right">
            <div id="topbar" class="desktop">
                <div id="searchbar">
                    <Suchfeld />
                </div>
                <div id="lang" class:active="{selectopen}">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="trigger"
                        on:click="{() => (selectopen = !selectopen)}"
                        style="text-transform: uppercase;"
                    >
                        {$sprache}
                        <span class="icon"
                            ><img src="/media/arrow_down.svg" alt="" /></span
                        >
                    </div>
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <div
                        class="overlay"
                        on:click="{() => (selectopen = false)}"
                    >
                        <a href="/" class="option">DE</a>
                        <a href="/en" class="option">EN</a>
                    </div>
                </div>
            </div>
            <nav id="navbar">
                <!-- svelte-ignore a11y-click-events-have-key-events -->
                <div id="pull" on:click="{() => (navopen = !navopen)}">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div id="navholder" class:active="{navopen}">
                    <div id="topbar" class="mobile">
                        <div id="searchbar">
                            <Suchfeld />
                        </div>
                        <div id="lang" class:active="{selectopen}">
                            <!-- svelte-ignore a11y-click-events-have-key-events -->
                            <div
                                class="trigger"
                                on:click="{() => (selectopen = !selectopen)}"
                            >
                                DE
                                <span class="icon"
                                    ><img
                                        src="/media/arrow_down.svg"
                                        alt=""
                                    /></span
                                >
                            </div>
                            <div class="overlay">
                                <a href="/de" class="option">DE</a>
                                <a href="/en" class="option">EN</a>
                            </div>
                        </div>
                    </div>
                    {#if $navstore[0]}
                        <Navigation
                            data="{$navstore[0]}"
                            level="{1}"
                            depth="{3}"
                            bind:navopen
                        />
                    {:else}
                        <LadeAnimation />
                    {/if}
                </div>
            </nav>
        </div>
    </div>
</header>

<style lang="less" global>
    @import "../css/base.less";

    #header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #fff;
        height: 120px;
        z-index: 3000;
        width: 100%;
        .inner {
            width: 100%;
            height: 100%;
            max-width: 1640px;
            padding: 0px 20px;
            margin-left: auto;
            margin-right: auto;
            .flex();
            justify-content: space-between;
        }
        @media (max-width: 640px) {
            border-bottom: solid 2px @maincolor;
        }
        #logo {
            width: auto;
            height: 80px;
            img {
                height: 100%;
                width: auto;
            }
        }
        #right {
            padding-top: 15px;
            .flex();
            flex-direction: column;
            align-items: flex-end;
        }
        #topbar {
            .flex();
            &.mobile {
                display: none;
            }
            @media (max-width: 640px) {
                height: 60px;
                background: #fff;
                border-bottom: solid 1px #ccc;
                align-items: center;
                justify-content: space-between;
                padding: 0px 20px;
                &.desktop {
                    display: none;
                }
                &.mobile {
                    .flex();
                }
            }
        }
    }
    #searchicon_mobile {
        display: none;
        @media (max-width: 640px) {
            display: block;
            margin-left: 15px;
            img {
                height: 23px;
            }
        }
    }
    #searchbar {
        position: relative;
        width: 150px;
        margin-right: 10px;
        :global {
            form {
                position: relative;
                @media (max-width: 640px) {
                    width: 200px;
                }
            }
            input {
                width: 100%;
                height: 30px;
                padding: 5px 35px 5px 15px;
                border: solid 1px #cfcfcf;
                outline: none;
                .transition();
                .border-radius(30px);
                @media (max-width: 640px) {
                    height: 35px;
                }
                &:focus {
                    border-color: @maincolor;
                }
            }
            button {
                border: none;
                background: none;
            }
        }
        .icon {
            position: absolute;
            right: 15px;
            top: 0;
            bottom: 0;
            .flex();
            align-items: center;
            img {
                height: 50%;
            }
        }
    }
    #lang {
        position: relative;
        .trigger {
            height: 30px;
            position: relative;
            border: solid 1px #cfcfcf;
            outline: none;
            padding: 0px 15px;
            .transition();
            .border-radius(30px);
            width: 80px;
            cursor: pointer;
            .flex();
            justify-content: space-between;
            align-items: center;
            color: #9f9f9f;
            font-size: 0.8rem;
            @media (max-width: 640px) {
                height: 35px;
            }
            .icon {
                .flex();
                justify-content: center;
                align-items: center;
            }
        }
        .overlay {
            .opacity(0);
            visibility: hidden;
            position: absolute;
            top: 200%;
            .border-radius(15px);
            border: solid 1px #cfcfcf;
            width: 80px;
            padding: 5px 0px;
            font-size: 0.8rem;
            background: #fff;
            z-index: 2100;
            .transition();
            .option {
                color: @textcolor;
                display: block;
                cursor: pointer;
                padding: 5px 15px;
                .transition();
                &:hover {
                    color: @maincolor;
                }
            }
        }
        &.active .overlay {
            .opacity(1);
            visibility: visible;
            top: 140%;
        }
    }

    // Navigation
    @media (min-width: 1270px) {
        #pull {
            display: none;
        }
        #navbar #navholder > ul {
            margin: 5px 0px 0px 0px;
            padding: 0px;
            .flex();
            list-style-type: none;
            li {
                position: relative;
            }
            li .arrow {
                display: none;
            }
            a {
                color: @textcolor;
                font-size: 0.9rem;
                cursor: pointer;

                &:hover {
                    color: @maincolor;
                }
            }
            > li {
                > a {
                    display: block;
                    padding: 10px;
                    .transition();
                }
            }

            // Submenus
            > li {
                ul {
                    border-top: solid 2px @maincolor;
                    z-index: 300;
                    position: absolute;
                    top: 130%;
                    min-width: 300px;
                    list-style-type: none;
                    .opacity(0);
                    visibility: hidden;
                    .transition();
                    background: #fff;
                    padding: 10px 0px;
                    li {
                        padding: 0px 15px;
                        a {
                            font-size: 0.9rem;
                            display: block;
                            border-bottom: dotted 1px #ccc;
                            padding: 7px 0px;
                            .transition();
                        }
                        &:last-child > a {
                            border: none;
                        }
                    }
                }
            }

            > li ul {
                li.haschildren {
                    > a {
                        padding-right: 30px;
                        &:after {
                            content: "\203A";
                            position: absolute;
                            top: -6px;
                            right: 18px;
                            font-size: 30px;
                        }
                    }

                    & ul {
                        left: 100%;
                        top: -12px;
                    }
                }
            }

            > li:nth-child(3) > ul,
            > li:nth-child(4) > ul,
            > li:nth-child(5) > ul,
            > li:nth-child(6) > ul,
            > li:last-child > ul {
                right: 0;
                left: inherit;

                li.haschildren {
                    > a {
                        padding-left: 30px;
                        &:after {
                            content: "\2039";
                            position: absolute;
                            top: -6px;
                            left: 18px;
                            font-size: 30px;
                        }
                    }

                    & ul {
                        left: auto;
                        right: 100% !important;
                        top: -12px;
                    }
                }
            }

            // Hovers and Actives
            > li:hover > a,
            > li.active > a {
                background: @maincolor;
                color: #fff;
            }
            > li > ul > li > a:hover {
                color: @maincolor;
            }

            // Submenu open on hover
            li:hover > ul {
                top: 100%;
                .opacity(1);
                visibility: visible;
            }
        }
    }

    // Only Mobile
    @media (min-width: 200px) and (max-width: 1270px) {
        #header {
            height: 80px;
            #logo {
                height: 60px;
            }
            #right {
                padding-top: 0px;
                flex-direction: row;
                align-items: center;
            }
            #navbar {
                #navholder {
                    overflow-y: scroll;
                    position: fixed;
                    top: 80px;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    background: #eeeeee;
                    margin-left: -100%;
                    z-index: 1000;
                    .transition();
                    &.active {
                        margin-left: 0;
                    }
                    ul {
                        margin: 0px;
                        padding: 0px;
                        list-style-type: none;
                        li a {
                            border-bottom: solid 1px rgba(0, 0, 0, 0.1);
                            padding: 0px 20px;
                            .flex();
                            align-items: center;
                            justify-content: space-between;
                            color: @textcolor;
                            width: 100%;
                            height: 50px;
                            position: relative;
                        }
                        li {
                            position: relative;
                        }
                        li .arrow {
                            display: none;
                        }
                        li.haschildren > .arrow {
                            .transition();
                            position: absolute;
                            right: 0;
                            top: 0;
                            z-index: 1000;
                            width: auto;
                            .flex();
                            width: 50px;
                            height: 50px;
                            align-items: center;
                            justify-content: center;
                        }
                        // Level 2
                        > li > ul {
                            // background:rgba(0,0,0,0.05);
                            .opacity(0);
                            height: auto;
                            max-height: 0;
                            .transition();
                            visibility: hidden;
                            background: #fff;
                            li {
                                a {
                                    border-bottom: dotted 1px rgba(0, 0, 0, 0.1);
                                    font-size: 0.8rem;
                                    // padding-left:40px;
                                }
                            }
                        }
                        // Level 2 active
                        > li.active {
                            > ul {
                                .opacity(1);
                                visibility: visible;
                                max-height: 2000px;
                            }
                            > .arrow {
                                transform: rotate(180deg);
                            }
                        }
                    }
                }
            }
        }
        #pull {
            display: block;
            width: 30px;
            margin-left: 20px;
            span {
                display: block;
                width: 100%;
                height: 2px;
                background: #333;
                margin: 6px 0px;
                &:nth-child(2) {
                    width: 70%;
                }
            }
        }
    }
</style>
